/*
 * This file is auto-generated. Do not modify it manually!
 */
import React from 'react';

import clsx from '@proton/utils/clsx';

import { MIME_ICON_VIEWBOX, type MimeIconComponentProps, getMimeIconAsset } from '../component';

export const MimeKeytrust = ({ alt, title, size = 4, className, ...rest }: MimeIconComponentProps) => {
    const asset = getMimeIconAsset(size);

    return (
        <>
            <svg
                role="img"
                viewBox={MIME_ICON_VIEWBOX[asset]}
                focusable="false"
                className={clsx(`icon-size-${size}`, className)}
                {...rest}
            >
                {title ? <title>{title}</title> : null}
                {asset === 'sm' && (
                    <g>
                        <rect width="16" height="16" rx="2" fill="#DADBE0"></rect>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M10.625 5.75896C10.625 6.5923 9.9494 7.26793 9.11588 7.26793C8.28237 7.26793 7.60676 6.5923 7.60676 5.75896C7.60676 4.92563 8.28237 4.25 9.11588 4.25C9.9494 4.25 10.625 4.92563 10.625 5.75896ZM11.25 5.75896C11.25 6.93752 10.2945 7.89293 9.11588 7.89293C8.64035 7.89293 8.20115 7.73741 7.84636 7.47447L5.45116 9.90538L6.30971 10.7639C6.43176 10.8859 6.43176 11.0838 6.30971 11.2058C6.18767 11.3278 5.9898 11.3278 5.86776 11.2058L5.01084 10.3489L4.3749 10.9848L5.23182 11.8417C5.35386 11.9637 5.35386 12.1616 5.23182 12.2836C5.10978 12.4056 4.9119 12.4056 4.78986 12.2836L3.93294 11.4268C3.68886 11.1827 3.68886 10.787 3.93294 10.5429L4.78904 9.68688L7.40379 7.03314C7.13868 6.67756 6.98176 6.23658 6.98176 5.75896C6.98176 4.58041 7.93724 3.625 9.11588 3.625C10.2945 3.625 11.25 4.58041 11.25 5.75896Z"
                            fill="#3A3F4A"
                        ></path>
                    </g>
                )}
                {asset === 'md' && (
                    <g>
                        <path
                            d="M0 2.5C0 1.11929 1.11929 0 2.5 0H21.5C22.8807 0 24 1.11929 24 2.5V21.5C24 22.8807 22.8807 24 21.5 24H2.5C1.11929 24 0 22.8807 0 21.5V2.5Z"
                            fill="#DADBE0"
                        ></path>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M15.8751 8.86255C15.8751 10.0292 14.9292 10.9751 13.7623 10.9751C12.5954 10.9751 11.6495 10.0292 11.6495 8.86255C11.6495 7.69588 12.5954 6.75 13.7623 6.75C14.9292 6.75 15.8751 7.69588 15.8751 8.86255ZM16.7501 8.86255C16.7501 10.5125 15.4124 11.8501 13.7623 11.8501C13.0965 11.8501 12.4817 11.6324 11.985 11.2643L8.63167 14.6675L9.83365 15.8694C10.0045 16.0403 10.0045 16.3173 9.83365 16.4881C9.66279 16.659 9.38577 16.659 9.21491 16.4881L8.01522 15.2885L7.12491 16.1788L8.3246 17.3784C8.49546 17.5492 8.49546 17.8262 8.3246 17.9971C8.15373 18.1679 7.87671 18.1679 7.70585 17.9971L6.50617 16.7975C6.16445 16.4558 6.16445 15.9018 6.50617 15.5601L7.7047 14.3616L11.3654 10.6464C10.9942 10.1486 10.7745 9.53122 10.7745 8.86255C10.7745 7.21257 12.1122 5.875 13.7623 5.875C15.4124 5.875 16.7501 7.21257 16.7501 8.86255Z"
                            fill="#3A3F4A"
                        ></path>
                    </g>
                )}
                {asset === 'lg' && (
                    <g>
                        <path
                            d="M3.39001 7.82496C3.39001 4.03076 6.46582 0.954956 10.26 0.954956H27.9481C29.7183 0.954956 31.4202 1.63829 32.6989 2.86247L42.4909 12.2368C43.8445 13.5327 44.61 15.3253 44.61 17.1993V42.175C44.61 45.9692 41.5342 49.045 37.74 49.045H10.26C6.46582 49.045 3.39001 45.9692 3.39001 42.175V7.82496Z"
                            fill="#DADBE0"
                        ></path>
                        <path
                            d="M44.4742 15.84H35.45C32.2881 15.84 29.725 13.2768 29.725 10.115V1.18872C30.8322 1.48522 31.8572 2.05667 32.6989 2.86246L42.4908 12.2368C43.5121 13.2146 44.1987 14.4751 44.4742 15.84Z"
                            fill="#EBECF0"
                        ></path>
                        <path
                            d="M44.6099 17.5574H35.4499C31.3396 17.5574 28.0074 14.2253 28.0074 10.1149V0.9552C28.5921 0.960253 29.1689 1.03981 29.7249 1.18871V10.1149C29.7249 13.2768 32.2881 15.8399 35.4499 15.8399H44.4742C44.5638 16.2841 44.6099 16.7392 44.6099 17.1993V17.5574Z"
                            fill="#BABBC5"
                        ></path>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M29.75 24.5179C29.75 26.1846 28.3988 27.5359 26.7318 27.5359C25.0647 27.5359 23.7135 26.1846 23.7135 24.5179C23.7135 22.8513 25.0647 21.5 26.7318 21.5C28.3988 21.5 29.75 22.8513 29.75 24.5179ZM31 24.5179C31 26.875 29.0891 28.7859 26.7318 28.7859C25.7807 28.7859 24.9023 28.4748 24.1927 27.9489L19.4023 32.8108L21.1194 34.5277C21.3635 34.7718 21.3635 35.1675 21.1194 35.4116C20.8753 35.6557 20.4796 35.6557 20.2355 35.4116L18.5217 33.6979L17.2498 34.9697L18.9636 36.6834C19.2077 36.9274 19.2077 37.3232 18.9636 37.5672C18.7196 37.8113 18.3238 37.8113 18.0797 37.5672L16.3659 35.8535C15.8777 35.3654 15.8777 34.574 16.3659 34.0858L18.0781 32.3738L23.3076 27.0663C22.7774 26.3551 22.4635 25.4732 22.4635 24.5179C22.4635 22.1608 24.3745 20.25 26.7318 20.25C29.0891 20.25 31 22.1608 31 24.5179Z"
                            fill="#3A3F4A"
                        ></path>
                    </g>
                )}
            </svg>
            {alt ? <span className="sr-only">{alt}</span> : null}
        </>
    );
};
